module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Mehinaku")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "head02",
    attrs: {
      "id": "fm_1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Contents#fm1"
    }
  }, [_vm._v("Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter2#fig_1"
    }
  }, [_vm._v("  1. Map of Brazil showing the location of the Mehinaku village")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter2#fig_2"
    }
  }, [_vm._v("  2. Xingu topography")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter2#fig_3"
    }
  }, [_vm._v("  3. The fascination of the outside world")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter2#fig_4"
    }
  }, [_vm._v("  4. A Mehinaku view of everyday village life")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter3#fig_5"
    }
  }, [_vm._v("  5. A heliocentric cosmology")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter3#fig_6"
    }
  }, [_vm._v("  6. Akanai’s map of the known world")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter3#fig_7"
    }
  }, [_vm._v("  7. Aerial view of Mehinaku village")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter3#fig_8"
    }
  }, [_vm._v("  8. The Mehinaku village, January 1972")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter3#fig_9"
    }
  }, [_vm._v("  9. Three views of the Mehinaku village")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter3#fig_10"
    }
  }, [_vm._v("10. The true house")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter4#fig_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. A mother grooms her daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter4#fig_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The chief’s foot")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter6#fig_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Come and drink "), _c('i', [_vm._v("nukaiya")]), _vm._v("!")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter7#fig_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Playing outside the village")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter9#fig_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Alligatoring")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#fig_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Dressing in front of the men’s house")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#fig_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Examples of hair designs")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#fig_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Women’s adornment")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#fig_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Amairi in seclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#fig_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Variations in seclusion partitions")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#fig_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Residence and kinship")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#fig_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Mehinaku consanguineal kinship terminology, simplified")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#fig_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Joking with a cross-cousin")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17#fig_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Kinds of fathers-in-law")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18#fig_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. A monkey")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18#fig_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. A wild Indian")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f27"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter19#fig_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. The dance of the Kaiyapa demon")])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "f28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter20#fig_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. Shamanism")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d1c80da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Frontmatter01.vue
// module id = 69
// module chunks = 0